import { BrowserModule } from '@angular/platform-browser';
import { NgModule, Optional, SkipSelf, APP_INITIALIZER } from '@angular/core';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { HttpClient, HttpClientModule, HttpClientXsrfModule } from '@angular/common/http';
import { WindowRef } from './services/window.service';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from '../../environments/environment';
import { APP_BASE_HREF } from '@angular/common';
import { LanguageService } from './services/language.service';



// Core module contains singleton services, single-instance components and exports and third-party modules required in AppModule
export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient, environment.translationPath + './assets/i18n/', '.json');
}

export function getAppBaseHref($window: WindowRef): string {
    return $window.nativeWindow.location.pathname + $window.nativeWindow.location.search + environment.appBaseHref;
}

@NgModule({
    declarations: [],
    imports: [
        BrowserModule,
        HttpClientModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        HttpClientXsrfModule.withOptions({
            cookieName: 'BBXSRF',
            headerName: 'X-BBXSRF',
        })
    ],
    exports: [
    ],
    providers: [
        WindowRef,
        LanguageService,
        {provide: APP_BASE_HREF, useFactory: getAppBaseHref, deps: [WindowRef]}
    ]
})

export class CoreModule {
    constructor(@Optional() @SkipSelf() core: CoreModule) {
        if (core) {
            throw new Error('Core Module should only be imported once, in AppModule');
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts